if (jQuery.fn.selectWoo) {
  $(".woocommerce-input-wrapper .select").selectWoo();

  $(".woocommerce-checkout .shipping_method").selectWoo();

  $(document.body).on(
    "updated_checkout updated_shipping_method",
    function (event, xhr, data) {
      $(".woocommerce-checkout .shipping_method").selectWoo();
    }
  );
}
